import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import KontrimanLoader from "../global/KontrimanLoader";

const CreateAccountPage = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Account Details:", {
      firstName,
      lastName,
      email,
      phone,
      password,
    });
  };
    useEffect(() => {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 500); 
      return () => clearTimeout(timer);
    }, []);
  
    if (loading) return <KontrimanLoader />;

  return (
<Container fluid className="vh-100 d-flex align-items-center position-relative px-0">
  
  {/* Icon at the Top Left */}
  <div className="position-absolute top-0 start-0 p-3">
    <a href="/">
      <FaHome size={30} color="#004080" />
    </a>
  </div>
  
  <Container className="px-0 px-md-3 w-100">
    <Row className="w-100 mx-0">
      <Col md={12} className="d-flex flex-column justify-content-center px-3 px-md-5">
      <h2 className="text-center mb-2">Create Your Kontriman Account</h2>
      <p className="text-center text-dark mb-4">
            Secure, fast, and reliable banking at your fingertips.
          </p>
        <br />
        <Form onSubmit={handleSubmit}>
          
          <Form.Group className="mb-3">
            <Form.Label>Enter First Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Your First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Enter Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Type your last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Enter Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter a valid email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Enter Phone Number</Form.Label>
            <Form.Control
              type="tel"
              placeholder="Enter your cell phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Enter Secret PIN</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter your PIN"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button type="submit" className="w-100 custom-button">
            Done
          </Button>

        </Form>
        <br />
        <div className="text-center mt-3">
          Already have an account?{" "}
          <Link to="/login" className="text-primary text-decoration-none">
            Login
          </Link>
        </div>
      </Col>

    </Row>
  </Container>
</Container>
  );
};

export default CreateAccountPage;
